import { render, staticRenderFns } from "./EditorFormColumn.vue?vue&type=template&id=71038147&"
import script from "./EditorFormColumn.vue?vue&type=script&lang=js&"
export * from "./EditorFormColumn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports